// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__vLAKg","productName":"Table_productName__3cfRp"};